<template>
  <div class="das-form-container">
    <div class="das-form-group">
      <section>
        <CustomerFormImageUpload
          :images="documents_image"
          :uploaded-images="uploaded_documents_image"
          @deleteImage="onDeleteImage"
          @uploadImage="onUploadImage"
        ></CustomerFormImageUpload>
      </section>
      <section class="details-section">
        <div class="details-section__column">
          <div v-if="showSearchField" class="das-form-input">
            <div class="label">{{ $t('field.profile') }}</div>
            <el-row>
              <div class="input-group">
                <input
                  v-model="formData.profile_name"
                  type="text"
                  disabled
                  :placeholder="$t('field.profile')"
                />
                <div class="input-group__append input-group-btn">
                  <button @click="onClearForm">
                    <i class="el-icon-delete"></i>
                  </button>
                  <button @click="isCustomerTableDialogOpened = true">
                    <i class="el-icon-search"></i>
                  </button>
                </div>
              </div>
            </el-row>
          </div>
          <div class="das-form-input das-form-input--first-name">
            <label class="label das-label">
              {{ $t('field.firstName') }}
            </label>
            <div class="das-form-input__input-group--first-name">
              <el-select v-model="formData.name" @change="onChangeName">
                <el-option label="Mr" value="Mr">Mr</el-option>
                <!-- <el-option label="Mrs" value="Mrs">Mrs</el-option> -->
                <el-option label="Ms" value="Ms">Ms</el-option>
              </el-select>
              <input v-model="formData.last_name" type="text" />
            </div>
          </div>
          <div class="das-form-input">
            <label class="label das-label das-label--required">
              {{ $t('field.lastName') }}
            </label>
            <div>
              <input v-model="formData.first_name" type="text" />
            </div>
          </div>

          <!-- <div class="das-form-input">
            <label class="label">
              {{ $t('field.phoneNumber') }}
            </label>
            <div class="input-group">
              <vue-tel-input
                v-model="formData.phone_number"
                v-numeric-only
                default-country="VN"
                :input-options="{
                  showDialCode: true,
                  placeholder: 'Số điện thoại'
                }"
                :valid-characters-only="true"
                @country-changed="onCountryChanged"
              />
              <div class="input-group__append input-group-btn">
                <button
                  :disabled="!canSearchDuplicateCustomer"
                  @click="onFindDuplicateCustomer"
                >
                  Kiểm tra
                </button>
              </div>
            </div>
          </div> -->

          <validation-provider
            tag="div"
            class="das-form-input"
            :rules="`phoneNumber:${formData.countryObject?.iso2},+${formData.countryObject?.dialCode}`"
            :name="$t('field.phoneNumber')"
          >
            <label class="label">
              {{ $t('field.phoneNumber') }}
            </label>
            <div class="input-group">
              <tel-input
                v-model="formData.phone_number"
                @phoneObj="onUpdateInput"
                @country-changed="onCountryChanged"
              />
              <div class="input-group__append input-group-btn">
                <button
                  :disabled="!canSearchDuplicateCustomer"
                  @click="onFindDuplicateCustomer"
                >
                  Kiểm tra
                </button>
              </div>
            </div>
          </validation-provider>

          <div class="das-form-input">
            <label class="label">
              {{ $t('field.email') }}
            </label>
            <div>
              <input v-model="formData.email" type="text" />
            </div>
          </div>
        </div>
        <div class="details-section__column">
          <div class="das-form-input">
            <label class="label required">
              {{ $t('field.sex') }}
            </label>
            <div>
              <el-select v-model="formData.sex">
                <el-option :key="1" label="Nam" :value="1"></el-option>
                <el-option :key="2" label="Nữ" :value="2"></el-option>
              </el-select>
            </div>
          </div>

          <div class="das-form-input das-form-input--first-name">
            <label class="label required">
              {{ $t('field.customerClass') }}
            </label>
            <div>
              <el-select v-model="formData.customer_level" clearable filterable>
                <el-option
                  v-for="option in travellerLevelOptions"
                  :key="option.code"
                  :label="option.desc"
                  :value="option.code"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="das-form-input das-form-input--first-name">
            <label class="label required">
              {{ $t('field.memberCount') }}
            </label>

            <input v-model="formData.member_id" type="text" />
          </div>

          <div class="das-form-input">
            <label class="label required">
              {{ $t('field.dateOfBirth') }}
            </label>
            <div>
              <CalendarSelect
                v-model="formData.birth"
                :min-max="{ max: new Date() }"
                mode="date"
              />
            </div>
          </div>
          <div class="das-form-input das-form-input--first-name">
            <label class="label required">
              {{ $t('field.nationality') }}
            </label>

            <el-select v-model="formData.nationality_id" clearable filterable>
              <el-option
                v-for="option in nationOptions"
                :key="option.id"
                :label="option.desc"
                :value="option.id"
              >
                <span style="float: left">{{ option.desc }}</span>
                <span
                  style="
                    float: right;
                    color: var(--el-text-color-secondary);
                    font-size: 13px;
                  "
                  >{{ option.code }}</span
                >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="details-section__column">
          <div class="das-form-input">
            <label class="label">
              {{ $t('field.address_1') }}
            </label>
            <div>
              <input v-model="formData.address_1" type="text" />
            </div>
          </div>
          <div class="das-form-input">
            <label class="label">
              {{ $t('field.address_2') }}
            </label>
            <div>
              <input v-model="formData.address_2" type="text" />
            </div>
          </div>
          <div class="das-form-input">
            <label class="label">
              {{ $t('field.identityCardNumber') }}/{{ $t('field.passport') }}
            </label>
            <div>
              <input v-model="formData.id_card" type="text" />
            </div>
          </div>
          <div class="das-form-input">
            <label class="label">
              {{ $t('field.note') }}
            </label>
            <div>
              <textarea v-model="formData.note" style="width: 100%" rows="5" />
            </div>
          </div>
          <!-- <div class="das-form-input">
            <label class="label required">
              {{ $t('field.dateOfIssue') }}
            </label>
            <div>
              <CalendarSelect v-model="formData.id_issued_date" mode="date" />
            </div>
          </div>
          <div class="das-form-input">
            <label class="label required">
              {{ $t('field.placeOfIssue') }}
            </label>
            <div>
              <input
                v-model="formData.identity_card_place_of_issue"
                type="text"
              />
            </div>
          </div> -->
        </div>
      </section>
    </div>
    <el-dialog
      :visible.sync="isCustomerTableDialogOpened"
      title="Danh sách khách hàng"
      width="70%"
    >
      <CustomerTable
        ref="CustomerTable"
        :visible="isCustomerTableDialogOpened"
        @onCustomerChecked="onCustomerChecked"
      ></CustomerTable>
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; gap: 10px; justify-content: flex-end"
      >
        <button class="btn primary small" @click="onSelectCustomer">
          Chọn
        </button>
        <button
          class="btn primary small outline"
          @click="isCustomerTableDialogOpened = false"
        >
          Đóng
        </button>
      </span>
    </el-dialog>
    <el-dialog
      :visible="isCustomerProfileDialogOpened"
      title="Thông tin khách hàng"
      append-to-body
      @close="isCustomerProfileDialogOpened = false"
    >
      <CustomerInfoDialog
        :customer-record="duplicateCustomer"
      ></CustomerInfoDialog>
      <div slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="onSelectDuplicateCustomer"
          >
            Lựa chọn
          </button>
          <button
            class="btn primary small"
            @click="isCustomerProfileDialogOpened = false"
          >
            Đóng
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getListNation } from '@/api/common/code_base'
import { getTravellerByIdApi } from '@/api/configuration/profile/traveller'
import { findDuplicateTraveller } from '@/api/configuration/profile/traveller'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import CustomerFormImageUpload from './CustomerFormImageUpload.vue'
import CustomerTable from './CustomerTable.vue'
import CustomerInfoDialog from './CustomerInfoDialog.vue'
import { validEmail } from '@/utils/validate'
import { notifyError } from '@/utils/toast'
import { getCodeListApi } from '@/api/common/code'
import { BOOKING_FORM_CONST } from '@/constant'
export default {
  components: {
    CustomerFormImageUpload,
    CalendarSelect,
    CustomerTable,
    CustomerInfoDialog
  },
  props: {
    showSearchField: {
      default: () => true
    },
    recordData: {
      default: null
    }
  },
  data() {
    return {
      phoneObject: null,
      isCustomerProfileDialogOpened: false,
      duplicateCustomer: null,
      checkedCustomer: null,
      formData: {
        countryObject: null,
        profile_id: null,
        profile_name: null,
        name: 'Mr',
        first_name: null,
        last_name: null,
        birth: null,
        sex: 1,
        customer_level: null,
        member_id: null,
        nationality_id: null,
        address_1: null,
        address_2: null,
        phone_number: null,
        email: null,
        id_card: null,
        id_issued_date: null,
        note: null,

        back_image: null,
        front_image: null,
        is_delete_front_image: false,
        is_delete_back_image: false
      },

      travellerLevelOptions: [],
      nationOptions: [],

      // Dialogs
      isCustomerTableDialogOpened: false,
      isSearchProfileToastVisible: false,
      isSearchProfileDialogVisible: false,
      isDuplicateProfileFound: false,

      uploadedDocumentsFront: null,
      uploadedDocumentsBack: null
    }
  },
  computed: {
    documents_image() {
      return [this.formData.front_image, this.formData.back_image]
    },
    uploaded_documents_image() {
      return [this.uploadedDocumentsFront, this.uploadedDocumentsBack]
    },
    canSearchDuplicateCustomer() {
      return !(
        this.formData.first_name == null ||
        this.formData.phone_number == null ||
        this.formData.profile_id != null
      )
    }
  },
  async mounted() {
    await Promise.all([
      this.getTravellerLevelOptions(),
      this.getNationOptions()
    ])
    // this.hydrateForm()
  },
  methods: {
    onChangeName(value) {
      console.debug(value)
      if (value === 'Mr') {
        this.formData.sex = 1
      } else if (value === 'Ms' || value === 'Mrs') {
        this.formData.sex = 2
      }
    },
    onCountryChanged(countryObject) {
      this.formData.countryObject = countryObject
      // this.formData.phone_number.replace(this.dialCode, '')
      // this.formData.phone_number =
      //   countryObject.dialCode + this.formData.phone_number
      // this.dialCode = countryObject.dialCode
    },
    onUpdateInput(phoneObject) {
      this.phoneObject = phoneObject
    },
    async findDuplicateTraveller(phone, number) {
      await findDuplicateTraveller(null, phone, number)
        .then(response => {
          if (response?.data == null) {
            notifyError('customerNotFound')
            return
          }
          this.duplicateCustomer = response.data
          this.isCustomerProfileDialogOpened = true
        })
        .catch(() => {
          notifyError('customerNotFound')
        })
    },
    onSelectDuplicateCustomer() {
      this.$emit('selectDuplicateCustomer', this.duplicateCustomer)
      this.isCustomerProfileDialogOpened = false
    },
    onCustomerChecked(customer) {
      this.checkedCustomer = customer
    },
    async onSelectCustomer() {
      const traveller = await this.getCustomer(this.checkedCustomer.id)
      if (traveller != null) {
        this.isCustomerTableDialogOpened = false
      }
      if (traveller.birth) {
        traveller.birth = this.$moment(traveller.birth).format('YYYY-MM-DD')
      }

      this.hydrateForm(traveller)
      this.$emit('onSelectCustomer', traveller)
    },
    hydrateForm(
      traveller = null,
      uploadDocument = {
        uploadedDocumentsBack: null,
        uploadedDocumentsFront: null
      },
      type = null
    ) {
      this.uploadedDocumentsBack = uploadDocument?.uploadedDocumentsBack
      this.uploadedDocumentsFront = uploadDocument?.uploadedDocumentsFront
      if (traveller == null) {
        this.formData.profile_id = null
        this.formData.profile_name = null
        this.formData.name = 'Mr'
        this.formData.first_name = null
        this.formData.last_name = null
        this.formData.birth = null
        this.formData.sex = 1
        this.formData.member_id = null
        this.formData.customer_level = null
        this.formData.phone_number = '+84'

        this.formData.nationality_id = null
        this.formData.address_1 = null
        this.formData.address_2 = null
        this.formData.email = null

        this.formData.id_card = null
        this.formData.id_issued_date = null

        this.formData.back_image = null
        this.formData.front_image = null
        this.formData.note = null

        return
      }

      if (traveller.front_image != null) {
        this.formData.front_image = {
          url: `data:image;base64,${traveller.front_image}`
        }
      } else {
        this.formData.front_image = {
          url: null
        }
      }

      if (traveller.back_image != null) {
        this.formData.back_image = {
          url: `data:image;base64,${traveller.back_image}`
        }
      } else {
        this.formData.back_image = {
          url: null
        }
      }

      this.formData.profile_id = traveller.id
      this.formData.profile_name = traveller.code

      this.formData.name = traveller.name
      this.formData.first_name = traveller.first_name
      this.formData.last_name = traveller.last_name
      this.formData.birth = traveller.birth
      this.formData.sex = traveller.sex
      this.formData.member_id = traveller.member_id
      if (
        type !== BOOKING_FORM_CONST.HYDRATE_CUSTOMER_FORM_TYPE.SWIPE_ID_CARD
      ) {
        this.formData.phone_number =
          traveller.phone_number == null || traveller.phone_number === ''
            ? '+84'
            : traveller.phone_number
      }
      this.formData.email = traveller.email
      this.formData.nationality_id = traveller.nationality_id

      this.formData.customer_level = traveller.customer_level

      this.formData.address_1 = traveller.address_1
      this.formData.address_2 = traveller.address_2
      this.formData.note = traveller.note

      this.formData.id_card = traveller.id_card
      this.formData.id_issued_date = traveller.id_issued_date
    },
    onUploadImage(file, index) {
      const url = URL.createObjectURL(file)

      const image = {
        file: file,
        url: url
      }
      if (index === 0) {
        this.uploadedDocumentsFront = image
        this.formData.is_delete_front_image = false
      } else if (index === 1) {
        this.uploadedDocumentsBack = image
        this.formData.is_delete_back_image = false
      }
    },
    onDeleteImage(index, type) {
      if (type === 'FROM_RECORD') {
        if (index === 0) {
          this.formData.is_delete_front_image = true
          this.formData.front_image = null
        }
        if (index === 1) {
          this.formData.is_delete_back_image = true
          this.formData.back_image = null
        }
      } else if (type === 'UPLOADED') {
        if (index === 0) {
          this.uploadedDocumentsFront = null
        }
        if (index === 1) {
          this.uploadedDocumentsBack = null
        }
      }
    },
    onPhoneCountryChange(param) {
      this.formData.phone_number = param.dialCode
    },
    onContinueSearchDialog() {
      this.isSearchProfileDialogVisible = true
      this.isSearchProfileToastVisible = false
    },
    onCancelSearchDialog() {
      this.isSearchProfileToastVisible = false
    },
    async onFindDuplicateCustomer(name, phone_number) {
      if (
        this.formData.first_name == null ||
        this.formData.phone_number == null ||
        this.formData.profile_id != null
      ) {
        return
      }
      this.findDuplicateTraveller(
        this.formData.first_name,
        this.formData.phone_number
      )
    },
    async getCustomer(customerId) {
      const traveller = await getTravellerByIdApi({
        id: customerId
      })
        .then(response => {
          const message = response?.message || 'default'
          this.$message({
            message: this.$t(`successMsg.${message}`),
            type: 'success'
          })
          return response.data
        })
        .catch(err => {
          const message = err.response?.data?.message || 'default'
          this.$message({
            message: this.$t(`errorMsg.${message}`),
            type: 'error'
          })
          return null
        })
      return traveller
    },
    onClearForm() {
      this.hydrateForm()
      this.$emit('onClearForm')
    },
    dehydrateForm() {
      const formData = {
        traveller_id: this.formData.profile_id,
        name: this.formData.name,
        first_name: this.formData.first_name,
        last_name: this.formData.last_name,
        phone_number: this.phoneObject?.nationalNumber
          ? `+${this.phoneObject.countryCallingCode}${this.phoneObject.nationalNumber}`
          : '',
        email: this.formData.email,
        customer_level: this.formData.customer_level,
        member_id: this.formData.member_id,
        nationality_id: this.formData.nationality_id,
        sex: this.formData.sex,
        id_card: this.formData.id_card,
        id_issued_date: this.formData.id_issued_date,
        birth: this.formData.birth,
        note: this.formData.note,

        address_1: this.formData.address_1,
        address_2: this.formData.address_2,

        uploaded_document_front_file: null,
        uploaded_document_back_file: null,
        is_delete_front_image: this.formData.is_delete_front_image,
        is_delete_back_image: this.formData.is_delete_back_image
      }

      // Data is file or blob
      if (this.uploadedDocumentsFront !== null) {
        formData.uploaded_document_front_file =
          this.uploadedDocumentsFront?.file || this.uploadedDocumentsFront?.url
      }

      if (this.uploadedDocumentsBack !== null) {
        formData.uploaded_document_back_file =
          this.uploadedDocumentsBack?.file || this.uploadedDocumentsBack?.url
      }
      return formData
    },
    validateForm() {
      if (this.formData.last_name?.length > 30) {
        return this.$t('validation.maxLength', {
          field: 'họ',
          length: 30
        })
      }

      if (this.formData.first_name == null || this.formData.first_name === '') {
        return this.$t('validation.required', { field: 'tên' })
      } else if (this.formData.first_name.length > 30) {
        return this.$t('validation.maxLength', {
          field: 'tên',
          length: 30
        })
      }

      if (
        this.phoneObject?.nationalNumber != null &&
        this.phoneObject?.nationalNumber !== ''
      ) {
        if (this.phoneObject.nationalNumber.length < 9) {
          return this.$t('validation.minLength', {
            field: 'số điện thoại',
            length: 9
          })
        } else if (this.phoneObject.nationalNumber.length > 50) {
          return this.$t('validation.maxLength', {
            field: 'số điện thoại',
            length: 50
          })
        }
      }

      if (this.formData.note && this.formData.note.length > 200) {
        return this.$t('validation.maxLength', {
          field: 'ghi chú',
          length: 200
        })
      }

      if (this.formData.id_card && this.formData.id_card.length > 200) {
        return this.$t('validation.maxLength', {
          field: 'số căn cước/hộ chiếu',
          length: 30
        })
      }

      if (this.formData.address_1 && this.formData.address_1.length > 100) {
        return this.$t('validation.maxLength', {
          field: 'địa chỉ 1',
          length: 100
        })
      }

      if (this.formData.address_2 && this.formData.address_2.length > 100) {
        return this.$t('validation.maxLength', {
          field: 'địa chỉ 2',
          length: 100
        })
      }

      const email = this.formData.email
      if (email) {
        if (email.length > 50) {
          return this.$t('validation.maxLength', { field: 'email', length: 50 })
        }
        if (!validEmail(email)) {
          return this.$t('validation.email')
        }
      }

      const member_id = this.formData.member_id
      if (member_id) {
        if (member_id.length > 30) {
          return this.$t('validation.maxLength', {
            field: 'số thành viên',
            length: 30
          })
        }
      }

      return null
    },
    async getTravellerLevelOptions() {
      await getCodeListApi({ pCode: 'VIP' }).then(response => {
        this.travellerLevelOptions = response.data
      })
    },
    async getNationOptions() {
      await getListNation().then(response => {
        this.nationOptions = response.data
      })
    }
  }
}
</script>
<style scoped lang="scss">
.details-section__booking-details {
  grid-column-start: 1;
  grid-column-end: 4;

  textarea {
    max-width: 100%;
    min-width: 100%;
    width: 100%;
    height: fit-content;
  }
}

.details-section__column {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.col-span-3 {
  grid-column: span 3 / span 3;
}

.das-form-group {
  display: grid;
  gap: 24px;
  grid-template-columns: auto 1fr;

  .details-section {
    margin-top: 0;
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(3, minmax(0, 1fr));

    .das-form-input__input-group--first-name {
      display: grid;
      grid-template-columns: 1fr 3fr;
      gap: 8px;
    }

    &__buttons-container {
      grid-column-start: 3;
      column-span: all;
      place-self: end;
    }

    &__note-section {
      grid-column: 1 / -1;

      textarea {
        width: 100%;
        max-width: 100%;
      }
    }
  }
}

.mt-2 {
  margin-top: 6px;
}
</style>
